// src/components/Reports/ReportSummary.js
import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import UptimeSummary from './Summaries/UptimeSummary';
import PerformanceSummary from './Summaries/PerformanceSummary';
import SecuritySummary from './Summaries/SecuritySummary';
import SeoSummary from './Summaries/SeoSummary';

const ReportSummary = ({ reportType, summary }) => {
    const renderSummaryContent = () => {
        switch (reportType) {
            case 'uptime':
                return <UptimeSummary summary={summary} />;
            case 'performance':
                return <PerformanceSummary summary={summary} />;
            case 'security':
                return <SecuritySummary summary={summary} />;
            case 'seo':
                return <SeoSummary summary={summary} />;
            default:
                return null;
        }
    };

    return (
        <Card className="shadow-sm">
            <Card.Header className="bg-white">
                <h5 className="mb-0">Shrnutí reportu</h5>
            </Card.Header>
            <Card.Body className="p-4">
                {renderSummaryContent()}
            </Card.Body>
        </Card>
    );
};

export default ReportSummary;